import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=6f765b5c&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f765b5c",
  null
  
)

export default component.exports